"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const emotion_1 = require("emotion");
const lodash_sortby_1 = __importDefault(require("lodash.sortby"));
const canDo_1 = __importDefault(require("../../utils/canDo"));
const Link_1 = require("./Link");
const setupI18n_1 = __importDefault(require("../../utils/setupI18n"));
const AtmsApiClient_1 = __importDefault(require("../../utils/AtmsApiClient"));
const LIST_SIZE = 50; // LIST_SIZE returned by web if we get this many back there could be more pages
const CreateNewButton = react_router_1.withRouter(({ session, listSize = LIST_SIZE }) => {
    const [showModal, setShowModal] = react_1.useState(false);
    const init = () => ({
        project: {
            name: setupI18n_1.default.t('Project'),
            permission: 'project:create',
            url: '/web/project/create',
        },
        transMemory: {
            name: setupI18n_1.default.t('Translation Memory'),
            permission: 'transMemory:create',
            url: '/web/transMemory/create',
        },
        termBase: {
            name: setupI18n_1.default.t('Term Base'),
            permission: 'termBase:create',
            url: '/web/termBase/create',
        },
        user: { name: setupI18n_1.default.t('User'), permission: 'user:create', url: '/web/user/create' },
        client: { name: setupI18n_1.default.t('Client'), permission: 'client:create', url: '/web/client/create' },
    });
    const reducer = (state, action) => {
        switch (action.type) {
            case 'loadingProjectTemplates':
                return {
                    ...state,
                    project: {
                        ...state.project,
                        itemsLoading: true,
                        items: [],
                    },
                };
            case 'loadedProjectTemplates':
                return {
                    ...state,
                    project: {
                        ...state.project,
                        itemsLoading: action.items.length === listSize,
                        items: lodash_sortby_1.default(state.project.items.concat(action.items.map(({ id, templateName: name }) => ({
                            name,
                            url: `/web/project/create?templateId=${id}`,
                        }))), ({ name }) => name.toLowerCase()),
                    },
                };
            default:
                return state;
        }
    };
    const [items, dispatch] = react_1.useReducer(reducer, null, init);
    react_1.useEffect(() => {
        if (showModal && canDo_1.default(session, items.project.permission) && !items.project.items) {
            dispatch({ type: 'loadingProjectTemplates' });
            const fetchUntilDone = async (page = 0) => {
                try {
                    const items = await AtmsApiClient_1.default.httpGet(`/web/api/v8/projectTemplate/list?page=${page}`);
                    dispatch({ type: 'loadedProjectTemplates', items });
                    if (items.length === listSize) {
                        fetchUntilDone(page + 1);
                    }
                }
                catch (e) {
                    console.error(`Error fetching templates: ${e}`);
                }
            };
            fetchUntilDone();
        }
    }, [items, session, showModal, listSize]);
    // render the item (and its nested items)
    const renderItem = ({ url, name, items, itemsLoading }, className) => (react_1.default.createElement("li", { key: url },
        react_1.default.createElement(Link_1.Link, { to: url, onClick: () => setShowModal(false), className: className }, name),
        items && (react_1.default.createElement("ul", { className: emotion_1.css({ maxHeight: 35 * 5, overflowY: 'auto' }) },
            items.map(renderItem),
            itemsLoading && react_1.default.createElement(polaris_1.Spinner, null)))));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(polaris_1.Button, { onClick: () => setShowModal(true) }, "Create New"),
        showModal && (react_1.default.createElement(polaris_1.Modal, { visible: showModal, closeLabel: setupI18n_1.default.t('Close'), onDismiss: () => setShowModal(false), header: setupI18n_1.default.t('Create New...'), footer: react_1.default.createElement("span", { className: "awsui-util-f-r" },
                react_1.default.createElement(polaris_1.Button, { variant: "link", text: setupI18n_1.default.t('Cancel'), onClick: () => setShowModal(false) })) },
            react_1.default.createElement("ul", null, Object.keys(items)
                .map(key => items[key])
                .filter(({ permission }) => canDo_1.default(session, permission))
                .map(item => renderItem(item, emotion_1.css({ fontWeight: 'bold' }))))))));
});
exports.default = Object.assign(CreateNewButton, {
    permissions: [
        'project:create',
        'transMemory:create',
        'termBase:create',
        'user:create',
        'client:create',
    ],
});
//# sourceMappingURL=CreateNewButton.js.map